import { memo } from "react";
import { View } from "react-native";
import { paddingLarge } from "src/styles/spacing";
import { GatheringHeaderProps } from "../types";

const GatheringHeaderEndSection = ({
	renderEndSection,
	variant,
}: Pick<GatheringHeaderProps, "variant"> & {
	renderEndSection: NonNullable<GatheringHeaderProps["renderEndSection"]>;
}) => {
	return (
		<View
			style={{
				marginTop: paddingLarge,
			}}
		>
			{renderEndSection()}
		</View>
	);
};
export default memo(GatheringHeaderEndSection);
